<template>
    <b-modal
        :id="modalId"
        centered
        hide-header
        hide-footer
    >
        <div class="text-center">
            <img class="mb-3" src="@/assets/icons/error.svg" alt="error">
            <p class="mb-3">{{ $t('modalerror.youLoseData') }}</p>
            <h6 class="mb-3">{{ $t('modalerror.youLoseDataConfirm') }}</h6>
        </div>

        <div class="float-right">
            <hemocir-button
                variant="primary"
                class="mr-3"
                @click="goBack"
            >
                {{ $t('utils.yes') | capitalize }}
            </hemocir-button>

            <hemocir-button
                variant="secondary"
                @click="$bvModal.hide(modalId)"
            >
               {{ $t('utils.no') | capitalize }}
            </hemocir-button>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: "ExitConfirmDialog",
        props: {
            modalId: {
                type: String,
                required: true,
            },
            backRoute: {
                type: Object,
                default: null,
            }
        },
        methods: {
            goBack() {
                if (this.backRoute === null) {
                    this.$router.go(-1);
                } else {
                    this.$router.push(this.backRoute);
                }
            }
        },
    };
</script>

<style scoped>

</style>